<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :items="hostingSshPublicKeys"
    >
      <template #item.actions="{ item }">
        <v-menu bottom offset-y min-width="180">
          <template v-slot:activator="{ on, attrs }">
            <gg-btn v-on="on" v-bind="attrs">
              Manage <v-icon right>mdi-chevron-down</v-icon>
            </gg-btn>
          </template>
          <v-list>
            <v-list-item @click="openModal('view', item)">
              <v-list-item-title>View/Download</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('manage', item)">
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openModal('delete', item)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <delete-ssh-key-modal
      v-if="selectedSshKey"
      pub="1"
      :opened="modals.delete"
      :ssh-key="selectedSshKey"
      @close="closeModal('delete')"
      @key-deleted="reload"
    />
    <view-ssh-key-modal
      v-if="selectedSshKey"
      pub="1"
      :opened="modals.view"
      :ssh-key="selectedSshKey"
      @close="closeModal('view')"
    />
    <manage-ssh-key-modal
      v-if="selectedSshKey"
      :opened="modals.manage"
      :ssh-key="selectedSshKey"
      @ssh-key-updated="reload"
      @close="closeModal('manage')"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import DeleteSshKeyModal from './DeleteSshKeyModal'
import ViewSshKeyModal from './ViewSshKeyModal'
import ManageSshKeyModal from './ManageSshKeyModal'

export default {
  name: 'PublicKeysTable',
  components: {
    DeleteSshKeyModal,
    ViewSshKeyModal,
    ManageSshKeyModal,
  },
  props: {
    tableShouldBeReloaded: {
      type: Boolean,
      required: false,
    },
  },
  data () {
    return {
      loading: false,
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Authorization Status',
          value: 'authstatus',
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false,
        }
      ],
      selectedSshKey: null,
      modals: {
        delete: false,
        view: false,
        manage: false,
      },
    }
  },
  computed: mapGetters(['hostingSshPublicKeys', 'pagination']),
  methods: {
    ...mapActions(['loadHostingSshPublicKeysList', 'reportError']),
    openModal (modal, ssh) {
      this.modals[modal] = true
      this.selectedSshKey = { ...ssh }
    },
    closeModal (modal) {
      this.modals[modal] = false
      this.selectedSshKey = null
    },
    reload () {
      this.loading = true
      this.loadHostingSshPublicKeysList(this.$route.query.user).then(
        () => {
          this.loading = false
          this.$emit('table-reloaded', { publicTable: true })
        },
        error => {
          this.loading = false
          this.reportError(error)
        }
      )
    },
  },
  watch: {
    tableShouldBeReloaded (val) {
      if (val) {
        this.reload()
      }
    }
  },
  created () {
    this.reload()
  }
}
</script>
